import {Component, HostBinding, HostListener, Input, OnInit} from '@angular/core';
import {GeoWidgetStateService} from './geo-widget-state.service';
import {ResizeEdgesModel} from '../models/resize-edges.model';
import {WidgetName} from '../enums/geo-widget-name.enum';

export interface WidgetStyle {
  width: number;
  height?: number;
}

@Component({
  selector: 'app-geo-widget',
  templateUrl: './geo-widget.component.html',
  styleUrls: ['./geo-widget.component.scss']
})
export class GeoWidgetComponent implements OnInit {
  @Input() resizeEdges: ResizeEdgesModel;
  @Input() widgetName: WidgetName;
  @Input() baseStyle: WidgetStyle;
  @Input() autoHeight = false;
  @HostBinding('style.width.px') styleWidth: number;
  styleHeight: number | null;

  @HostBinding('style.height')
  get hostHeight(): string | null {
    if (this.autoHeight) {
      return 'auto';
    }
    return this.styleHeight != null ? `${this.styleHeight}px` : null;
  }

  constructor(private state: GeoWidgetStateService) {
  }

  ngOnInit() {
    const saved = this.state.loadState(this.widgetName);

    this.styleWidth = saved && saved.width || this.baseStyle.width || 400;
    this.styleHeight = saved && saved.height || this.baseStyle.height || null;
  }

  @HostListener('resizeEnd', ['$event']) onResizeEnd(event) {
    if (event.edges.right || event.edges.left) {
      this.styleWidth = event.rectangle.width;
    }
    if (event.edges.bottom || event.edges.top) {
      this.styleHeight = event.rectangle.height;
    }

    this.state.saveState(this.widgetName, {
      width: this.styleWidth,
      height: this.styleHeight
    });
  }
}
